<template>
  <md-table v-model="schedules" table-header-color="black" class="schedule schedule-table font">
    {{page}}
    <md-table-row slot="md-table-row" slot-scope="{ item }">
      <!--первая ячейка в строке-->
      <md-table-cell :md-label="local_page_keys.label_kiev_time + (timeRoundedToUpper30Seconds ? ' ( '+ timeRoundedToUpper30Seconds +' ) ': '') ">
        {{ item[0] }}
        <!--отметка ночного времени-->
        <span v-if="isNight(item[0])" :data-uk-tooltip="local_page_keys.schedule_tooltip_moon_description"><i class="md-icon tm-scheduletable-icon">bedtime</i></span>
        <!--отметка текущего времени-->
        {{currentShiftTime(item[0])}}
      </md-table-cell>

      <md-table-cell
          v-for="day in filterDaysToShow(Object.entries(item[1]),20)"
          :key="day.worker"
          :md-label="getLabel(day[0]) + (isAdmin() ? getCountOrder(day[0]): '')"
          :class="getClass(day[0])"
          :id="'cell-'+day[0]+item[0]"
      >

        <!--прилодер для ячейки-->
        <div class="loader-hide" :id="'cell-loader-'+day[0]+item[0]">
          <v-progress-circular :width="2" :size="20" indeterminate style="color: forestgreen"/>
        </div>



        <!--записан с зеленым человечком (ретушер)-->
        <div
            :data-uk-tooltip="getRetoucherWaitingTimeTooltipText('', item[0], day[0], true)"
            class="uk-text-center 1" v-if="!isAdmin() && !isPast(day[0], item[0]) && !isPastServerTime(day[0], item[0])  && isMember(day[1]) && mayToWrite(day[0]) ">
          <div>
            <div class="uk-grid uk-grid-collapse uk-flex-center uk-flex-middle">
              <div v-if="mayToReplace(day[1])" class="pointer">
                <div v-if="!mustCancelReplace(day[1])"
                     @click="showDialog(day[0], item[0], 'unsubscribe',null,null,null,null, day[1][0]['wasWritten'], isNotUnsubscribePeriod(day[0], item[0]))"
                     class="pointer uk-margin-xsmall-left">
                  <div class="uk-grid tm-grid-xsmall uk-flex-center uk-flex-middle">
                    <div>
                      {{local_page_keys.label_recorded_by}} {{currentShift(day[0],item[0])}}
                    </div>
                    <div v-if="isLocked(day[1])">
                      <md-icon class="material-icons icon-brown">
                        lock
                      </md-icon>
                    </div>
                    <div v-else>
                      <md-icon class="material-icons 3" :class="isNotUnsubscribePeriod(day[0], item[0]) ? ' icon-grey ' :' icon-green '" :data-uk-tooltip="local_page_keys.unsubscribe_tooltip">
                        person_remove
                      </md-icon>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else-if="!mayToReplace(day[1]) && !mustCancelReplace(day[1])"  class="pointer uk-margin-xsmall-left">
                {{local_page_keys.label_recorded_by}}
              </div>
              <div v-else-if="mustCancelReplace(day[1])" class="uk-margin-xsmall-left">
                {{local_page_keys.label_recorded_by}}
              </div>
              <div v-if="mustCancelReplace(day[1])" class="pointer uk-margin-xsmall-left">
                🔄
              </div>
              <div class="tm-scheduletable-bonus-penalty uk-margin-xsmall-left" :class="getBonusPenaltyValue(day,item,true).valueClass">
                {{getBonusPenaltyValue(day,item,true).value }}
              </div>
            </div>
          </div>
        </div>
        <!--Записан + замочек (ретушер)-->
        <div
            :data-uk-tooltip="getRetoucherWaitingTimeTooltipText('', item[0], day[0], true)"
            class="uk-text-center 2" v-else-if="isAdminView() && !isPast(day[0], item[0]) && !isPastServerTime(day[0], item[0])  && isMember(day[1]) && !mustCancelReplace(day[1])">
          <div>
            <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
              <!--надпись ЗАПИСАН-->
              <div v-if="mayToReplace(day[1])" @click="showDialog(day[0], item[0], 'unsubscribe')" class="pointer">
                {{local_page_keys.label_recorded_by}}
              </div>
              <!--lock-->
              <div v-if="typeof retoucher == 'string' &&  retoucher.length > 0 && typeof keyLockIsChecked[item[0]][day[0]] != 'undefined' && typeof keyLockIsChecked[item[0]][day[0]][retoucher] != 'undefined'">
                <label class="tm-scheduletable-dropdown-list-cell uk-display-block" style="cursor: pointer;">
                  <input type="checkbox"
                         style="position: absolute;display: none;"
                         :id="'keyLockToggleCheckRef-' + item[0]+day[0]+retoucher"
                         :checked="keyLockIsChecked[item[0]][day[0]][retoucher]['set_to_work'] == 2"
                         @change="keyLockToggleCheck($event, day[0],item[0], retoucher)">
                  <md-icon>
                    {{ keyLockIsChecked[item[0]][day[0]][retoucher]['set_to_work'] == 2 ? 'lock' : 'lock_open' }}
                  </md-icon>
                </label>
              </div>
              <div class="tm-scheduletable-bonus-penalty uk-margin-xsmall-left" :class="getBonusPenaltyValue(day,item,true).valueClass">
                {{getBonusPenaltyValue(day,item,true).value }}
              </div>
            </div>
          </div>
        </div>
        <!--Записан + замочек красный + сервый человечек (ретушер)-->
        <div
            :data-uk-tooltip="getRetoucherWaitingTimeTooltipText('', item[0], day[0], 'short')"
            class="uk-text-center 3" v-else-if="!isAdmin() && !isPast(day[0], item[0]) && !isPastServerTime(day[0], item[0])  && !mayToWrite(day[0]) && isMember(day[1]) ">
          <div>
            <div class="uk-grid uk-grid-collapse uk-flex-center uk-flex-middle">
              <div v-if="!mustCancelReplace(day[1])"
                   @click="showDialog(day[0], item[0], 'unsubscribe',null,null,null,null, day[1][0]['wasWritten'], isNotUnsubscribePeriod(day[0], item[0]))"
                   class="pointer uk-margin-xsmall-left">
                <div class="uk-grid tm-grid-xsmall uk-flex-center uk-flex-middle">
                  <div>
                    {{local_page_keys.label_recorded_by}} {{currentShift(day[0],item[0])}}
                  </div>
                  <div v-if="isLocked(day[1])">
                    <md-icon class="material-icons icon-brown 1" :data-uk-tooltip="local_page_keys.mandatory_shift_tooltip">
                      lock
                    </md-icon>
                  </div>
                  <div v-else>
                    <md-icon v-if="isNotUnsubscribePeriod(day[0], item[0])" class="material-icons 2 icon-grey" :data-uk-tooltip="local_page_keys.can_not_unsubscribe_tooltip">
                      person_add
                    </md-icon>
                    <md-icon v-else class="material-icons 4 icon-green" :data-uk-tooltip="local_page_keys.unsubscribe_tooltip">
                      person_remove
                    </md-icon>
                  </div>
                </div>
              </div>
              <div v-else-if="mustCancelReplace(day[1])" class="uk-margin-xsmall-left">
                {{local_page_keys.label_recorded_by}} {{currentShift(day[0],item[0])}}
              </div>
              <div v-if="mustCancelReplace(day[1])" class="pointer uk-margin-xsmall-left">
                {{currentShift(day[0],item[0])}} 🔄
              </div>
              <div class="tm-scheduletable-bonus-penalty uk-margin-xsmall-left" :class="getBonusPenaltyValue(day,item,true).valueClass">
                {{getBonusPenaltyValue(day,item,true).value }}
              </div>
            </div>
          </div>
        </div>
        <div class="uk-text-center 4" v-else-if="isAdminView() && !isPast(day[0], item[0]) && !isPastServerTime(day[0], item[0])  && mustCancelReplace(day[1]) && isMember(day[1]) ">
          <div>
                  <span>
                    {{local_page_keys.label_recorded_by}} {{currentShift(day[0],item[0])}}
                  </span>
            <span v-if="mustCancelReplace(day[1])" @click="showDialog(day[0], item[0], 'cancell of replacement by admin')" class="pointer">
                    {{currentShift(day[0],item[0])}} 🔄
                  </span>
          </div>
        </div>
        <!--батарейка + показатели-->
        <div class="uk-text-center 5" v-else>
          <div v-if="isPast(day[0], item[0]) && isPastServerTime(day[0], item[0]) && (isMember(day[1]) || isFakeMember(day[1]))">
            <div v-if="!isAdmin() || isAdminView()">
              <div class="uk-grid uk-grid-small uk-flex-middle uk-flex-center" data-uk-grid>
                <div>
                  <!--{{getWaitingTime(day[1])}}-->
                  <span v-if="isAdmin()">#{{getWaitingTime(day[1], true)['doneOrders']}}</span> <span>🕛{{getWaitingTime(day[1], true)['waitingTime']}}</span>
                </div>
                <div>
                  <div class="uk-grid uk-child-width-auto uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                    <!--описание для админа-->
                    <div v-if="isAdmin()" class="batteryOuter" :class="getClassBattery(getTime(day[1]), day[1]) + (isFakeMember(day[1]) ? ' tm-battery-black ': '')">
                      <div class="uk-grid uk-child-width-1-4 uk-flex-middle" data-uk-grid :data-battery="getTime(day[1])">
                        <div class="uk-text-danger uk-text-center uk-width-1-1" style="line-height: 10px;font-size: 8px;" v-if="getTime(day[1]) === 0 && !day[1][0].done_orders">
                          {{local_page_keys.scheduletable_empty}}
                        </div>
                        <div v-if="getTime(day[1]) > 0">
                          <div class="batteryLevel"></div>
                        </div>
                        <div v-if="getTime(day[1]) > 15">
                          <div class="batteryLevel"></div>
                        </div>
                        <div v-if="getTime(day[1]) > 29">
                          <div class="batteryLevel"></div>
                        </div>
                        <div v-if="getTime(day[1]) > 45">
                          <div class="batteryLevel"></div>
                        </div>
                      </div>
                    </div>
                    <!--описание для не админа-->
                    <div v-else class="batteryOuter" :class="getClassBattery(getTime(day[1]), day[1]) + (isFakeMember(day[1]) ? ' tm-battery-black ': '')">
                      <div class="uk-grid uk-child-width-1-4 uk-flex-middle" data-uk-grid :data-battery="getTime(day[1])">
                        <div class="uk-text-danger uk-text-center uk-width-1-1" style="line-height: 10px;font-size: 8px;" v-if="getTime(day[1]) === 0 && !day[1][0].done_orders">
                          {{local_page_keys.scheduletable_empty}}
                        </div>
                        <div v-if="getTime(day[1]) > 0">
                          <div class="batteryLevel"></div>
                        </div>
                        <div v-if="getTime(day[1]) > 15">
                          <div class="batteryLevel"></div>
                        </div>
                        <div v-if="getTime(day[1]) > 29">
                          <div class="batteryLevel"></div>
                        </div>
                        <div v-if="getTime(day[1]) > 45">
                          <div class="batteryLevel"></div>
                        </div>
                      </div>
                    </div>
                    <div class="batteryBump"></div>
                    <div  v-if="!isFakeMember(day[1])" class="tm-scheduletable-bonus-penalty uk-margin-xsmall-left" :class="getBonusPenaltyValue(day,item,true).valueClass">
                      {{ getBonusPenaltyValue(day,item,true).value }}
                    </div>
                  </div>
                </div>
              </div>
              <!--всплывающее описание-->
              <div class="uk-dropdown tm-scheduletable-battery-dropdown" data-uk-dropdown="mode: hover; pos: bottom-left; offset: 5; delay-show: 300; shift: true" style="padding: 0;">
                <div class="uk-padding-xsmall">
                  <div class="tm-grid-xsmall uk-grid-small uk-child-width-1-1 uk-text-left" data-uk-grid>
                    <div v-if="isAdmin()">
                      #{{getWaitingTime(day[1], true)['doneOrders']}} - фактические кол-во выполенных заказов
                    </div>
                    <div>
                      🕛{{getWaitingTime(day[1], true)['waitingTime']}} - <span v-html="getRetoucherWaitingTimeTooltipText(local_page_keys.schedule_tooltip_crown_description_waiting_extension_0_part,item[0], day[0])"></span>
                    </div>
                    <!--мини батарейка-->
                    <div>
                      <div class="uk-grid uk-grid-collapse" data-uk-grid>
                        <div class="uk-width-auto">
                          <div class="batteryOuter" :class="getClassBattery(getTime(day[1])) + (isFakeMember(day[1]) ? ' tm-battery-black ': '')">
                            <div class="uk-grid uk-child-width-1-4 uk-flex-middle" data-uk-grid>
                              <div class="uk-text-danger uk-text-center uk-width-1-1" style="line-height: 6px;font-size: 7px;" v-if="getTime(day[1]) === 0">
                                {{local_page_keys.scheduletable_empty}}
                              </div>
                              <div v-if="getTime(day[1]) > 0">
                                <div class="batteryLevel"></div>
                              </div>
                              <div v-if="getTime(day[1]) > 15">
                                <div class="batteryLevel"></div>
                              </div>
                              <div v-if="getTime(day[1]) > 29">
                                <div class="batteryLevel"></div>
                              </div>
                              <div v-if="getTime(day[1]) > 45">
                                <div class="batteryLevel"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="uk-width-expand" style="line-height: 1.1">
                          <template v-if="isAdmin()">{{getTime(day[1])}}</template> - расчетное значение минут работы на этой смене
                        </div>
                      </div>
                    </div>
                    <!--описание-->
                    <div v-if="!isAdmin()">
                      {{ getDiscBattery2(getTime(day[1])) }}
                    </div>
                    <div v-html="descriptionBonusPenaltyValue(getBonusPenaltyValue(day,item,true))"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="!isAdminView() && !isAdmin() && isPast(day[0], item[0]) && isPastServerTime(day[0], item[0]) ">
            {{currentShift(day[0],item[0])}}
          </div>
          <div
              :data-uk-tooltip="getRetoucherWaitingTimeTooltipText('', item[0], day[0], 'short')"
              v-if=" !isAdminView() && !isAdmin() && !isMember(day[1]) &&  !isPastServerTime(day[0], item[0]) && doNotDisplayIfSumProductivityPerShiftOver(day[0],item[0]) && doNotDisplayIfShiftInRangeAndTowards(day[0],item[0], 96, 96, 8,18)">
            <!--кнопка ЗАПИСАТЬ-->
            <button
                type="button"
                class="uk-button tm-button-schedule-table tm-button-scheduletable-success 111"
                @click="showDialog(day[0], item[0], 'subscribe')">
              {{ local_page_keys.button_recorded_by }} {{currentShift(day[0],item[0])}}
            </button>
          </div>
          <div v-else-if="!isAdminView() && !isAdmin() && isMember(day[1]) &&  !isPastServerTime(day[0], item[0]) && doNotDisplayIfSumProductivityPerShiftOver(day[0],item[0]) && doNotDisplayIfShiftInRangeAndTowards(day[0],item[0], 96, 96, 8,18)">
            <div class="uk-grid uk-grid-collapse uk-flex-center uk-flex-middle">
              <div v-if="!mustCancelReplace(day[1])"
                   @click="showDialog(day[0], item[0], 'unsubscribe',null,null,null,null, day[1][0]['wasWritten'], isNotUnsubscribePeriod(day[0], item[0]))"
                   class="pointer uk-margin-xsmall-left">
                <div class="uk-grid tm-grid-xsmall uk-flex-center uk-flex-middle">
                  <div>
                    {{local_page_keys.label_recorded_by}} {{currentShift(day[0],item[0])}}
                  </div>
                  <div v-if="isLocked(day[1])">
                    <md-icon class="material-icons icon-brown 1" :data-uk-tooltip="local_page_keys.mandatory_shift_tooltip">
                      lock
                    </md-icon>
                  </div>
                  <div v-else>
                    <md-icon class="material-icons 2" :class="isNotUnsubscribePeriod(day[0], item[0]) ? ' icon-grey ' :' icon-green '" :data-uk-tooltip="local_page_keys.can_not_unsubscribe_tooltip">
                      person_add
                    </md-icon>
                  </div>
                </div>
              </div>
              <div v-else-if="mustCancelReplace(day[1])" class="uk-margin-xsmall-left">
                {{local_page_keys.label_recorded_by}} {{currentShift(day[0],item[0])}}
              </div>
              <div v-if="mustCancelReplace(day[1])" class="pointer uk-margin-xsmall-left">
                {{currentShift(day[0],item[0])}} 🔄
              </div>
            </div>
          </div>
        </div>
      </md-table-cell>
    </md-table-row>
  </md-table>
</template>

<script>
import AdminCalendarComponent from "../../../components/AdminCalendarComponent.vue";
export default {
  name: "ScheduleRetoucherView",
  components: {},
  props: {
    showDialog: {
      type: Function,
      require: true
    },


    mayToReplace:{
      type: Function,
      required: true,
    },
    getLabel:{
      type: Function,
      required: true,
    },
    getTime:{
      type: Function,
      required: true,
    },
    doNotDisplayIfSumProductivityPerShiftOver:{
      type: Function,
      required: true,
    },
    doNotDisplayIfShiftInRangeAndTowards:{
      type: Function,
      required: true,
    },
    isNotUnsubscribePeriod:{
      type: Function,
      required: true,
    },
    getBonusPenaltyValue:{
      type: Function,
      required: true,
    },
    isAdmin:{
      type: Function,
      required: true,
    },
    isAdminView:{
      type: Function,
      required: true,
    },
    getWeekDay:{
      type: Function,
      required: true,
    },
    isPastServerTime:{
      type: Function,
      required: true,
    },
    isMember:{
      type: Function,
      required: true,
    },
    isFakeMember:{
      type: Function,
      required: true,
    },
    currentShift:{
      type: Function,
    },
    getCurrentDate:{
      type: Function,
      required: true,
    },
    isNight:{
      type: Function,
      required: true,
    },
    isPast:{
      type: Function,
      required: true,
    },
    currentShiftTime:{
      type: Function,
      required: true,
    },
    filterDaysToShow:{
      type: Function,
      required: true,
    },
    getClass:{
      type: Function,
      required: true,
    },
    mayToWrite:{
      type: Function,
      required: true,
    },
    mustCancelReplace:{
      type: Function,
      required: true,
    },
    isLocked:{
      type: Function,
      required: true,
    },
    getCountOrder:{
      type: Function,
      required: true,
    },
    getWaitingTime:{
      type: Function,
      required: true,
    },
    getClassBattery:{
      type: Function,
      required: true,
    },
    getDiscBattery2:{
      type: Function,
      required: true,
    },
    descriptionBonusPenaltyValue:{
      type: Function,
      required: true,
    },
    getRetoucherWaitingTimeTooltipText:{
      type: Function,
      required: true,
    },




    timeRoundedToUpper30Seconds:{
      type: String,
    },
    role:{
      type: String,
    },
    page:{
      type: Number,
    },
    local_page_keys:{
      type: Object,
      required: true,
    },
    retoucherView:{
      type: Boolean,
      required: true
    },
    schedules:{
      type: Array,
      required:true
    },
    serverTimeObj:{
      type: Object,
    },
    schedulesAll:{
      type: Object,
    },
    current_shift:{
      type: Object,
    },
    timeControl:{
      type: Object,
    },
    timeControlAll:{
      type: Object,
    }
  },
  data() {
    return {
      //keyLockIsChecked:{},
      keyLockIstoSet: false
    }
  },
  methods: {


  },
  computed: {}
}
</script>

<style scoped></style>
